export default "__VITE_ASSET__jctD4LFf__"